"use client";

import { FC } from "react";

import { LinkHandler } from "@/components/common/LinkHandler";
import { AccountIcon } from "@/components/icons/AccountIcon";
import { ArrowIcon } from "@/components/icons/ArrowIcon";
import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import { GA4 } from "@/utils/ga4Utils";
import { cn } from "@/utils/general";

import styles from "./NavSwitch.module.scss";

type NavType = "women" | "men" | "account" | "quiz" | "menquiz";

interface NavSwitcherProps {
  type?: NavType;
  copy?: string;
}

const destinationMap: Record<NavType, string> = {
  women: "/",
  men: "/men/",
  account: "/account/",
  quiz: "/hair/brand/quiz/",
  menquiz: "/hair/brand/quiz/",
};

const NavSwitcher: FC<NavSwitcherProps> = ({
  type = "women",
  copy = "Switch to Nutrafol Women",
}) => {
  const isQuiz = ["quiz", "menquiz"].includes(type);
  const isAccount = type === "account";

  const destination = destinationMap[type];

  const onRedirect = () => {
    if (isQuiz) {
      GA4.onMarketingCtaClicked({
        destination,

        text: copy,
        type: "button",
      });
      return;
    }

    GA4.onNavigationClicked({
      destination,
      type: "button",
      text: copy,
    });
  };

  const textColor = isQuiz || isAccount ? "text-nova-base-white" : "text-nova-base-black";

  const wrapperClass = cn(
    "h-full flex items-center flex-1",
    styles.navSwitcherFlex,
    isQuiz ? styles.flexQuiz : styles.flexRegular,
    isAccount ? styles.flexAccount : null
  );

  return (
    <div className={wrapperClass} onClick={(e) => e?.nativeEvent?.stopImmediatePropagation()}>
      <LinkHandler
        path={destination}
        className={cn(
          "flex items-center justify-center",
          isQuiz || isAccount ? "header-quiz-link" : ""
        )}
        onClick={onRedirect}
      >
        {isAccount ? <AccountIcon className="account-svg text-nova-base-white" /> : null}
        <TextElementNova element="p" text={copy} className={cn("CTA-10-Dia-Normal", textColor)} />
        {isQuiz || isAccount ? null : <ArrowIcon className="text-nova-base-black" />}
      </LinkHandler>
    </div>
  );
};

export default NavSwitcher;
